const Loader = ({ overlay = false, className = '' }) => {
	return (
		<div
			className={`h-screen w-full max-w-3xl mx-auto flex items-center justify-center touch-none ${
				className
			} ${overlay && 'bg-gray-400 opacity-50 fixed inset-0 z-50'}`}
		>
			<div className="w-full mx-auto flex justify-center items-center">
				<div className="h-fit w-fit">
					<img
						src="/assets/img/ufood-loader.gif"
						alt="gif"
						className="h-7 w-auto"
					/>
					<span className="sr-only">Loading...</span>
				</div>
			</div>
		</div>
	);
};

export default Loader;
